// This icon file is generated automatically.
var AuthorizeFilled = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M512 42.67L128 213.33v256c0 236.8 163.84 458.24 384 512 220.16-53.76 384-275.2 384-512v-256L512 42.67zm-85.33 682.66L256 554.67l60.16-60.16 110.5 110.08L707.85 323.4 768 384 426.67 725.33z" } }] }, "name": "authorize", "theme": "filled" };
export default AuthorizeFilled;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/AuthorizeFilled.js
// module id = 2043
// module chunks = 0